export default __webpack_public_path__ + "static/MainBannerLogo-394bc9f4afd3533f93283655f66aae02.png";